(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      if (root.dataset.plFaqInit === 'true') return;
      root.dataset.plFaqInit = 'true';

      var nav = root.querySelector('[data-pl-faq-nav]');
      var groups = Array.prototype.slice.call(root.querySelectorAll('.pl-faqp__group[id]'));
      if (!nav || !groups.length) return;

      nav.innerHTML = '';
      var links = groups.map(function (g) {
        var a = document.createElement('a');
        a.href = '#' + g.id;
        a.textContent = g.getAttribute('data-nav-label') || '';
        a.addEventListener('click', function (e) {
          e.preventDefault();
          g.scrollIntoView({ behavior: 'smooth', block: 'start' });
          setActive(g.id);
        });
        nav.appendChild(a);
        return a;
      });

      function setActive(id) {
        links.forEach(function (a) {
          var on = a.getAttribute('href') === '#' + id;
          a.classList.toggle('is-active', on);
          if (on) {
            a.setAttribute('aria-current', 'true');
          } else {
            a.removeAttribute('aria-current');
          }
        });
      }

      var LINE = 140;
      var ticking = false;

      function update() {
        ticking = false;
        var atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4;
        if (atBottom) {
          setActive(groups[groups.length - 1].id);
          return;
        }
        var current = groups[0].id;
        for (var i = 0; i < groups.length; i++) {
          if (groups[i].getBoundingClientRect().top - LINE <= 0) {
            current = groups[i].id;
          } else {
            break;
          }
        }
        setActive(current);
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      }

      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }

    function initAll(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('.pl-faqp').forEach(initFaq);
    }

    if (document.readyState !== 'loading') {
      initAll(document);
    } else {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelectorAll) initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-favorites-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const VIEW = '?view=pl-fav-card';

    const fetchCard = (root, handle) => {
      const base = root.dataset.productBase || '/products/';
      return fetch(base + encodeURIComponent(handle) + VIEW, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then((response) => (response.ok ? response.text() : ''))
        .catch(() => '');
    };

    const show = (parts, state) => {
      parts.loading.hidden = state !== 'loading';
      parts.items.hidden = state !== 'items';
      parts.empty.hidden = state !== 'empty';
    };

    const render = (root, handles) => {
      const parts = {
        loading: root.querySelector('[data-pl-favg-loading]'),
        items: root.querySelector('[data-pl-favg-items]'),
        empty: root.querySelector('[data-pl-favg-empty]'),
      };
      if (!parts.loading || !parts.items || !parts.empty) return;

      const token = String(handles);
      root.dataset.rendered = token;

      if (!handles.length) {
        parts.items.replaceChildren();
        show(parts, 'empty');
        return;
      }

      show(parts, 'loading');

      Promise.all(handles.map((handle) => fetchCard(root, handle))).then((cards) => {
        if (root.dataset.rendered !== token) return;
        const fragment = document.createDocumentFragment();
        cards.forEach((html) => {
          if (!html.trim()) return;
          const item = document.createElement('li');
          item.innerHTML = html;
          if (item.childElementCount) fragment.appendChild(item);
        });
        const rendered = fragment.childElementCount;
        parts.items.replaceChildren(fragment);
        show(parts, rendered === 0 ? 'empty' : 'items');
      });
    };

    const update = () => {
      if (!window.PLFavorites) return;
      const handles = window.PLFavorites.handles();
      document.querySelectorAll('[data-pl-fav-grid]').forEach((root) => {
        if (root.dataset.rendered === String(handles)) return;
        render(root, handles);
      });
    };

    document.addEventListener('pl:favorites:change', update);
    document.addEventListener('shopify:section:load', update);

    if (document.readyState !== 'loading') {
      update();
    } else {
      document.addEventListener('DOMContentLoaded', update, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(root) {
      if (root.dataset.plHeroInit === 'true') return;
      root.dataset.plHeroInit = 'true';

      var track = root.querySelector('.pl-hero__track');
      var slides = Array.prototype.slice.call(root.querySelectorAll('.pl-hero__slide'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('.pl-hero__dot'));
      var count = slides.length;
      if (!track || count === 0) return;

      var delay = parseInt(root.dataset.autoplay, 10) || 5000;
      var index = 0;
      var timer = null;

      function render() {
        track.style.transform = 'translateX(-' + index * 100 + '%)';
        slides.forEach(function (slide, i) {
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        dots.forEach(function (dot, i) {
          var active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      function goTo(i) {
        index = (i + count) % count;
        render();
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        if (count < 2) return;
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        stop();
        timer = window.setInterval(function () {
          goTo(index + 1);
        }, delay);
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          goTo(i);
          start();
        });
      });

      render();
      start();
    }

    function initAll() {
      document.querySelectorAll('.pl-hero').forEach(initHero);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    document.addEventListener('shopify:section:load', function (event) {
      var scope = event.target;
      if (!scope || !scope.querySelector) return;
      var hero = scope.querySelector('.pl-hero');
      if (hero) {
        hero.dataset.plHeroInit = '';
        initHero(hero);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-product-rail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var GAP = 16;

    function raf2(cb) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(cb);
      });
    }

    function mod(value, n) {
      return ((value % n) + n) % n;
    }

    function Carousel(track) {
      this.track = track;
      this.carousel = track.closest('.pl-carousel');
      this.panel = track.closest('.pl-rail__panel');
      this.rail = track.closest('.pl-rail');
      this.dotsWrap = this.panel ? this.panel.querySelector('.pl-carousel__dots') : null;
      this.dots = this.dotsWrap ? Array.prototype.slice.call(this.dotsWrap.querySelectorAll('.pl-carousel__dot')) : [];
      this.originals = Array.prototype.slice.call(track.children);
      this.count = this.originals.length;
      this.autoplayMs = this.rail && parseInt(this.rail.dataset.autoplay, 10) ? parseInt(this.rail.dataset.autoplay, 10) : 3200;
      this.index = 0;
      this.dragOffset = 0;
      this.timer = null;
      this.paused = false;
      this.dragging = false;
      this.dragStartX = 0;
      this.dragMoved = false;
      this.suppressClick = false;
      this.wheelLocked = false;
      this.resumeTimer = null;
      this.init();
    }

    Carousel.prototype.init = function () {
      if (this.count > 1) {
        var before = document.createDocumentFragment();
        var after = document.createDocumentFragment();
        for (var i = 0; i < this.count; i++) {
          before.appendChild(this.cloneCard(this.originals[i]));
          after.appendChild(this.cloneCard(this.originals[i]));
        }
        this.track.insertBefore(before, this.track.firstChild);
        this.track.appendChild(after);
        this.index = this.count;
      }
      this.apply(false);
      this.updateDots();
      this.wire();
      if (this.panel) {
        this.panel.__plCarousel = this;
      }
      this.start();
    };

    Carousel.prototype.cloneCard = function (card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      return clone;
    };

    Carousel.prototype.apply = function (animate) {
      this.track.classList.toggle('is-resetting', !animate);
      this.track.style.setProperty('--pl-slide-index', this.index);
      this.track.style.setProperty('--pl-drag-offset', this.dragOffset + 'px');
    };

    Carousel.prototype.updateDots = function () {
      if (!this.dots.length || this.count < 1) return;
      var active = mod(this.index, this.count);
      for (var i = 0; i < this.dots.length; i++) {
        var on = i === active;
        this.dots[i].classList.toggle('is-active', on);
        this.dots[i].setAttribute('aria-current', on ? 'true' : 'false');
      }
    };

    Carousel.prototype.stepPx = function () {
      var first = this.track.firstElementChild;
      return first ? first.getBoundingClientRect().width + GAP : 0;
    };

    Carousel.prototype.goBy = function (delta) {
      if (this.count <= 1) return;
      this.dragOffset = 0;
      this.index += delta;
      this.apply(true);
      this.updateDots();
    };

    Carousel.prototype.goTo = function (i) {
      if (this.count <= 1) return;
      this.dragOffset = 0;
      this.index = i;
      this.apply(true);
      this.updateDots();
    };

    Carousel.prototype.goToDot = function (i) {
      if (this.count <= 1) return;
      var current = this.index;
      var loop = Math.floor(current / this.count);
      var targets = [(loop - 1) * this.count + i, loop * this.count + i, (loop + 1) * this.count + i];
      var nearest = targets[0];
      for (var t = 1; t < targets.length; t++) {
        if (Math.abs(targets[t] - current) < Math.abs(nearest - current)) nearest = targets[t];
      }
      this.goTo(nearest);
    };

    Carousel.prototype.normalize = function () {
      if (this.count <= 1) return;
      if (this.index >= this.count * 2 || this.index < this.count) {
        var next = this.index >= this.count * 2 ? this.index - this.count : this.index + this.count;
        this.index = next;
        this.apply(false);
        var self = this;
        raf2(function () {
          self.track.classList.remove('is-resetting');
        });
      }
    };

    Carousel.prototype.reset = function () {
      this.index = this.count > 1 ? this.count : 0;
      this.dragOffset = 0;
      this.apply(false);
      this.updateDots();
      var self = this;
      raf2(function () {
        self.track.classList.remove('is-resetting');
      });
      this.paused = false;
      this.start();
    };

    Carousel.prototype.pause = function () {
      this.paused = true;
      if (this.resumeTimer) window.clearTimeout(this.resumeTimer);
      var self = this;
      this.resumeTimer = window.setTimeout(function () {
        self.paused = false;
      }, 5000);
    };

    Carousel.prototype.start = function () {
      this.stop();
      if (this.count <= 1) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var self = this;
      this.timer = window.setInterval(function () {
        if (self.paused || self.dragging) return;
        if (self.panel && self.panel.hidden) return;
        self.goBy(1);
      }, this.autoplayMs);
    };

    Carousel.prototype.stop = function () {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    };

    Carousel.prototype.wire = function () {
      var self = this;

      this.track.addEventListener('transitionend', function (e) {
        if (e.target !== self.track || e.propertyName !== 'transform') return;
        self.normalize();
      });

      if (this.carousel) {
        this.carousel.addEventListener('keydown', function (e) {
          if (self.count <= 1) return;
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            self.pause();
            self.goBy(1);
          } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            self.pause();
            self.goBy(-1);
          }
        });

        this.carousel.addEventListener('wheel', function (e) {
          if (self.count <= 1) return;
          if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
          if (Math.abs(e.deltaX) < 12) return;
          e.preventDefault();
          self.pause();
          if (self.wheelLocked) return;
          self.goBy(e.deltaX > 0 ? 1 : -1);
          self.wheelLocked = true;
          window.setTimeout(function () {
            self.wheelLocked = false;
          }, 1250);
        }, { passive: false });

        var prev = this.carousel.querySelector('.pl-carousel__nav--prev');
        var next = this.carousel.querySelector('.pl-carousel__nav--next');
        if (prev) prev.addEventListener('click', function () { self.pause(); self.goBy(-1); });
        if (next) next.addEventListener('click', function () { self.pause(); self.goBy(1); });
      }

      this.track.addEventListener('pointerdown', function (e) {
        if (self.count <= 1) return;
        self.dragStartX = e.clientX;
        self.dragMoved = false;
        self.pause();
        self.dragging = true;
        self.track.classList.add('is-dragging');
        self.dragOffset = 0;
      });

      this.track.addEventListener('pointermove', function (e) {
        if (!self.dragging) return;
        var offset = e.clientX - self.dragStartX;
        if (Math.abs(offset) > 8 && !self.dragMoved) {
          try { self.track.setPointerCapture(e.pointerId); } catch (err) {}
          self.dragMoved = true;
        }
        self.dragOffset = offset;
        self.track.style.setProperty('--pl-drag-offset', offset + 'px');
      });

      var finish = function (e) {
        if (!self.dragging) return;
        var offset = e.clientX - self.dragStartX;
        var step = self.stepPx();
        var threshold = step ? Math.min(120, step * 0.22) : 60;
        self.dragging = false;
        self.track.classList.remove('is-dragging');
        self.pause();
        if (self.dragMoved) self.suppressClick = true;
        var delta = step ? -Math.round(offset / step) : 0;
        if (delta === 0 && Math.abs(offset) > threshold) delta = offset < 0 ? 1 : -1;
        self.dragOffset = 0;
        self.index += delta;
        self.apply(true);
        self.updateDots();
      };
      this.track.addEventListener('pointerup', finish);
      this.track.addEventListener('pointercancel', finish);

      this.track.addEventListener('click', function (e) {
        if (!self.suppressClick) return;
        e.preventDefault();
        e.stopPropagation();
        self.suppressClick = false;
      }, true);

      if (this.dots.length) {
        this.dots.forEach(function (dot, i) {
          dot.addEventListener('click', function () {
            self.pause();
            self.goToDot(i);
          });
        });
      }
    };

    function initTabs(section) {
      var btns = Array.prototype.slice.call(section.querySelectorAll('.pl-rail-tab-btn'));
      var panels = Array.prototype.slice.call(section.querySelectorAll('.pl-rail__panel'));
      if (!btns.length) return;
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.dataset.tab;
          btns.forEach(function (b) {
            var on = b.dataset.tab === id;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            var on = p.dataset.tab === id;
            p.classList.toggle('is-active', on);
            p.hidden = !on;
            if (on && p.__plCarousel) p.__plCarousel.reset();
          });
        });
      });
    }

    function initAll(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('.pl-product-rail').forEach(function (track) {
        if (track.dataset.plInit === 'true') return;
        track.dataset.plInit = 'true';
        new Carousel(track);
      });
      scope.querySelectorAll('.pl-product-section').forEach(function (section) {
        if (section.dataset.plTabsInit === 'true') return;
        section.dataset.plTabsInit = 'true';
        initTabs(section);
      });
    }

    if (document.readyState !== 'loading') {
      initAll(document);
    } else {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelectorAll) initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
